
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/firestore",
      function () {
        return require("private-next-pages/destinations/firestore.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/firestore"])
      });
    }
  